<template>
    <div class="fans_table-container" :class="{disabled_after_offer: !isEditable}">
        <v-client-table name="FansTable"
                        ref="FanTable"
                        :data="getFansTableData"
                        :columns="getParamColumnsTitle"
                        :options="options"
                        @row-click="selectMainFan($event)">

            <template slot="h__TYP/MODEL">
                <div class="type_model_header">{{translate("type_model")}}</div>
                <div class="comparison_header">{{translate("comparition")}}</div>
            </template>

            <template v-for="(element, key) in getParamColumnsData"
                      :slot="'h__'+element.title">
                <div class="column_title-container">
                    <div class="title"><span>{{ translate(key) }}</span></div>
                    <div class="icon-arrows_top_bottom"></div>
                </div>

                <div class="text_input_container" :ref='key' v-if="element.type === 'text'">
                    <div class="custom-select">
                        <div class="selected_item"
                             @click.stop.prevent="toggleExpandOfCustomSelect">
                            <span class="value" v-html="translate(element.selected)"/>
                            <span class="icon-bottom_arrow"/>
                        </div>

                        <div class="items-container">
                            <div class="item"
                                 v-for="option in getSelectOptionsOfSpecificParam(key)"
                                 @click.stop.prevent="changeSelectedInParamsTable(option,key), toggleExpandOfCustomSelect($event)"
                                 v-html="translate(option)">
                            </div>
                        </div>
                    </div>
                </div>

                <div :class="{from_to_input_container : element.type === 'from_to', plus_minus_input_container : element.type === 'plus_minus'}"
                     v-if="element.type === 'from_to' || element.type === 'plus_minus'">
                    <div class="inputs-container"
                         @click.prevent.stop="consoleIt('inputs-container')">
                        <div :class="{from_to_range : element.type === 'from_to'}" v-if="element.type === 'from_to'">
                            {{translate('range_from_to')}}
                        </div>
                        <div :class="{from_to_plus_minus : element.type === 'plus_minus'}"
                             v-if="element.type === 'plus_minus'">{{translate('range_minus_plus')}}
                        </div>
                        <input :class="element.title"
                               :value="calcUnit(element, element.range_from, element.infinityMin)"
                               @input="setFilter(element, $event.target.value, 'range_from')"
                               type="tel">
                        <input :class="element.title"
                               :value="calcUnit(element, element.range_to, element.infinityMax)"
                               @input="setFilter(element, $event.target.value, 'range_to')"
                               type="tel">
                    </div>
                    <div class="custom-select" v-if="getUnitsCount(element.units, key) > 0">
                        <div class="selected_item"
                             @click.stop.prevent="toggleExpandOfCustomSelect">
                            <span class="value" v-html='getSelectedElement(element, "sdsdsds")'/>
                            <span class="icon-bottom_arrow"/>
                        </div>
                        <div class="items-container"
                             :class="{items_container_expanded: countSimilarFans > 1, items_container_short_expanded: countSimilarFans == 1, items_no_expand: countSimilarFans < 1 }">
                            <div class="item"
                                 v-for="unit in getUnits(element.units, key)"
                                 @click.stop.prevent="toggleExpandOfCustomSelect($event), changeSelectedInParamsTable(unit,key)"
                                 v-html="unit.value">
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template slot="TYP/MODEL" slot-scope="props">
                <div class="type_model_content">
                    <img class="fan-img" :src='"data:image/png;base64, " + props.row.imgSrc'>
                    <div class="text-container">
                        <span class="type" v-html="props.row.type"/>
                        <span class="model" v-html="props.row.model"/>
                    </div>
                </div>
                <div class="comparison_content" @click.stop='selectForCompare(props.row.id)'>
                    <span v-if="props.row.isActive" class="icon-ok"/>
                    <input v-else class="compare-radio_btn" type="radio" :checked="props.row.isCompared">
                </div>
            </template>


            <template v-for="item in getShortParamColumnsTitle" :slot="item" slot-scope="props">
                <span v-if="props.row.params[item]  == 0  &&  item == 'price'  ||  props.row.params[item] == undefined || (checkTemperatureCondition(props.row) &&  item == 'price')"
                      class="value"> - </span>
                <span v-else="props.row.params[item] " class="value"
                      v-html="calcUnitRowElement(props.row.params[item], item)"/>
            </template>
        </v-client-table>
    </div>
</template>

<script>
    import MaskedInput from "vue-masked-input";
    import Vue from 'vue';
    import debounce from 'lodash.debounce';

    window.Vue = Vue;

    export default {
        name: "FansTable",
        components: {MaskedInput},
        props: ['load'],
        data() {
            return {
                empty: {},
                isFilteredData: '',
                main_data_columns: ["TYP/MODEL"],
                filterChanges: [],
                tableHasReloadedBefore: false,
                options: {
                    customSorting: {},
                    customFilters: [],
                    perPage: 100000, //obejście braku możliwości wyświetlenia nielimitowanej ilości wierszy wiec wyświetlane jest tyle ponieważ nigdy do takiej wartosci sie nie dojdzie
                },
              previousPressure: null
            };
        },
        methods: {
            calculateDiscount(price) {
                return parseFloat(this.$priceController.calculateDiscount(price, this.$store.state.discount)).toFixed(2).toString();
            },

            setSorting(columnId) {
                if (this.getFansTableData) {
                    this.$store.state.FansTable.sortBy = columnId;
                    this.$store.state.FansTable.columns;
                }
            },

            setFilter(element, value, type) {
              this.filterChanges.push({
                 element, value, type
              });
              this.filterValues();
            },

            filterValues: debounce(function(){
                for(let change in this.filterChanges) {
                    if(isNaN(change)) break;
                    let a = this.filterChanges[change];
                    this.changeFilterValue(a.element, a.value, a.type);
                }
                this.filterChanges = [];
            },700),

            getUnits(units, key) {
                if (units && units.length > 0) {
                    return units;
                }

                if (key == "price") {
                    return [{active: true, unit: null, value: 'EUR'}]
                }

                if (key == "number_of_fans") {
                    return [{active: true, unit: null, value: this.translate("szt")}]
                }

                if (key == "pipeline_average_speed") {
                    return [{active: true, unit: null, value: 'm/s'}]
                }

                if (key == "average_rated_speed_of_the_fan") {
                    return [{active: true, unit: null, value: '1/min'}]
                }

                if (key == "maximum_rotor_speed") {
                    return [{active: true, unit: null, value: '1/min'}]
                }

                if (key == "fan_temperature_increase") {
                    return [{active: true, unit: null, value: '°C'}]
                }

                if (key == "max_medium_temperature") {
                    return [{active: true, unit: null, value: '°C'}]
                }

                if (key == "characteristic_coefficient") {
                    return [{active: true, unit: null, value: '-'}]
                }
            },

            getUnitsCount(units, key) {
                if (units && units.length > 0) {
                    return units.length;
                }
                if (key == "price" || key == "number_of_fans" || key == "pipeline_average_speed" || key == "average_rated_speed_of_the_fan" || key == "maximum_rotor_speed" || key == "characteristic_coefficient") {
                    return 1;
                }
            },

            manageSelectedFan() {
                this.$store.commit({
                    type: 'manageSelectedFan',
                });
            },

            getSelectedElement(element, d = "a") {
                if (element.title == "price") {
                    return 'EUR';
                }

                if (element.title == "number_of_fans") {
                    return this.translate("szt");
                }

                if (element.title == "pipeline_average_speed") {
                    return 'm/s';
                }

                if (element.title == "average_rated_speed_of_the_fan") {
                    return '1/min';
                }

                if (element.title == "maximum_rotor_speed") {
                    return '1/min';
                }

                if (element.title == "characteristic_coefficient") {
                    return '-';
                }

                if (element && element.type != "text")
                    for (let unitTmp of element.units) {
                        if (unitTmp.active)
                            return unitTmp.value
                    }
            },
            changeFilterValue(element, value, type) {
                let infinity = 0;

                if (value == "")
                    infinity = 1;

                if (type == "range_from")
                    element.infinityMin = infinity;
                else if (type == "range_to")
                    element.infinityMax = infinity;

                if (infinity == 1) {
                    this.$store.commit('FansTable/SET_CUSTOM_FILTER', {filter: element.title, value: Date.now()});

                    return;
                }


                let param = {value: value};
                let elements = this.$store.state.ValueUnitMap[element.title].selected;
                let option = null;

                if (elements)
                    option = {elements: {1: elements}};
                else
                    option = {
                        elements: {
                            1: {
                                active: true, value: "-", unit: {
                                    decimal_places: 0,
                                    a0: 0,
                                    a0d: 1,
                                    a1: 1,
                                    a1d: 1,
                                    designation: "Pa",
                                    flag_default: 1,
                                    id: null,
                                    name: "",
                                    type: ""
                                }
                            }
                        }
                    }

                let tmpRound = {
                    type: 'roundValue',
                    elements: option.elements,
                    value: value,
                    out: ""
                }

                this.$store.commit("roundValue", tmpRound);

                let tmpPayload = {
                    type: 'calcRestoreUnit',
                    param: param,
                    option: option,
                    value: tmpRound.out,
                    out: ""
                }

                this.$store.commit("calcRestoreUnit", tmpPayload);

                if (type == "range_from")
                    this.$store.commit("changeRangeFrom", {param_id: element.title, value: parseFloat(tmpPayload.out)});
                else if (type == "range_to")
                    this.$store.commit("changeRangeTo", {param_id: element.title, value: parseFloat(tmpPayload.out)});

                this.$store.commit('FansTable/SET_CUSTOM_FILTER', {filter: element.title, value: Date.now()});
            },

            calcUnit(element, value, infinity) {
                if (infinity == "1")
                    return "";

                if (!element.hasOwnProperty('selected') || !element.selected.hasOwnProperty("unit"))
                    return value;

                let param = {value: value};
                let option = {elements: {1: this.$store.state.ValueUnitMap[element.title].selected}};

                let arg = {
                    type: 'calcUnit',
                    param: param,
                    option: option,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            calcUnitRowElement(value, unitKey) {
                if (this.$store.state.fansTableData.params_table[unitKey].type == "text") {
                    return this.translate(value);
                }

                if (value == "nieobliczalne" || value == "+nieskończoność" || value == "-nieskończoność")
                    return "-";

                if (!this.$store.state.fansTableData.params_table[unitKey] || this.$store.state.fansTableData.params_table[unitKey].type == "text" || !this.$store.state.fansTableData.params_table[unitKey].hasOwnProperty('selected') || !this.$store.state.fansTableData.params_table[unitKey].selected.hasOwnProperty("unit")) {
                    if (unitKey == "price") {
                        return this.$priceController.convertWithThousandSeparator(this.calculateDiscount(value));
                    } else {
                        return value;
                    }
                }


                let param = {value: value};
                let option = {elements: {1: this.$store.state.ValueUnitMap[unitKey].selected}};

                let arg = {
                    type: 'calcUnit',
                    param: param,
                    option: option,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            changeSelectedInParamsTable(selected, param_id) {
                if (selected && selected.unit) {
                    this.$store.commit({
                        type: 'changeSelectedUnitInValueUnitMap',
                        param_id: param_id,
                        unitDescription: selected.value
                    });
                } else {
                    this.$store.commit({
                        type: 'changeSelectedInParamsTable',
                        param_id: param_id,
                        selected: selected
                    });
                }

                this.$forceUpdate();

                this.$store.commit('FansTable/SET_CUSTOM_FILTER', {filter: param_id, value: selected})
            },

            toggleExpandOfCustomSelect(e) {

                let target = e.target;

                document.querySelectorAll('.custom-select').forEach((select) => {

                    select.classList.remove("expanded");
                });

                while (target instanceof Element) {

                    if (target.classList.contains('selected_item')) {

                        target.parentElement.classList.toggle("expanded");
                        return;

                    } else if (
                        target.classList.contains('value') ||
                        target.classList.contains('icon-bottom_arrow')) {

                        target.parentElement.parentElement.classList.toggle("expanded");
                        return;

                    } else if (target.classList.contains('items-container')) {

                        target.parentElement.classList.remove("expanded");
                        return;

                    } else if (target.classList.contains('item')) {

                        target.parentElement.parentElement.classList.remove("expanded");
                        return;

                    } else {
                        return;
                    }
                }
            },

            getSelectOptionsOfSpecificParam(param_id) {

                let options_arr = [];
                let _this = this;

                options_arr.push("-")

                Object.keys(_this.getFansTableData).forEach(function (fan_id) {
                    let option = _this.getFansTableData[fan_id].params[param_id];
                    if (!options_arr.find(x => x == option))
                        options_arr.push(option);
                });

                return options_arr;
            },

            generateSortingMethod() {
                this.$store.commit({
                    type: 'generateSortingMethod',
                });
            },

            generateFilteringMethods() {
                this.$store.commit({
                    type: 'generateFilteringMethods',
                });
            },

            changeRangeFrom(e, param_id) {

                this.$store.commit({
                    type: 'changeRangeFrom',
                    param_id: param_id,
                    value: e.target.value
                });
            },

            changeRangeTo(e, param_id) {

                this.$store.commit({
                    type: 'changeRangeTo',
                    param_id: param_id,
                    value: e.target.value
                });
            },

            consoleIt(a) {
                // console.log(a)
            },

            translate(code) {
                let arg = {
                    type: 'translate',
                    code: code,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            selectForCompare(id) {

                this.$store.commit({
                    type: 'selectFanRowForCompareInFansTable',
                    fan_id: id
                });

            },

            setDefaultFilters() {
                //DRIVE DIRECT FILTER
                this.changeSelectedInParamsTable('drive_direct', 'drive');
            },

            selectMainFan(e) {

                if (!e.event.target.classList.contains("comparison_content")) {

                    this.$store.commit({
                        type: 'selectFanRowAsActiveInFansTable',
                        fan_id: e.row.id,
                        reset_params: true
                    });

                }

            },
            LoadTableSettings() {
                for (let param in this.$store.state.fansTableData.params_table) {
                    if (this.$store.state.fansTableData.params_table.hasOwnProperty(param)) {
                        delete this.$store.state.fansTableData.params_table[param]
                    }
                }

                for (let setting of this.$store.state.appTableParametersSettingsList) {
                    if (
                        setting.id_app_fan_sort && parseInt(setting.id_app_fan_sort) == this.$store.state.selectedSecondStepElement.id &&
                        setting.id_app_fan_type && parseInt(setting.id_app_fan_type) == this.$store.state.selectedFirstStepElement.id
                    ) {

                        if (setting.name == "fan_graphics" || setting.name == "fan_type" || setting.name == "fan_type_number") {


                        } else {

                            // let units = [];
                            let selected = {value: "-"};
                            let range_from = 0;
                            let range_to = 0;

                            if (setting.method_of_filtering == "text") {
                                selected = "-";
                            }

                            // if (setting.name === "drive") {
                            //     selected = "drive_direct";
                            // }

                            if ((setting.method_of_filtering == "from_to" || setting.method_of_filtering == "plus_minus") && this.$store.state.ValueUnitMap[setting.name]) {
                                for (let unitType of this.$store.state.ValueUnitMap[setting.name].units) {


                                    if (unitType.active == true) {
                                        // Object.assign(selected, this.$store.state.ValueUnitMap[setting.name].selected);

                                        let option = {elements: {1: unitType}};
                                        // let paramFrom = {value: setting.range_from }
                                        //  let paramTo = {value: setting.range_to }

                                        let tmpPayload = {
                                            type: 'calcRestoreUnit',
                                            option: option,
                                            value: setting.range_from,
                                            out: ""
                                        }

                                        this.$store.commit("calcRestoreUnit", tmpPayload);
                                        range_from = tmpPayload.out;

                                        let tmpPayloadTo = {
                                            type: 'calcRestoreUnit',
                                            option: option,
                                            value: setting.range_to,
                                            out: ""
                                        }

                                        this.$store.commit("calcRestoreUnit", tmpPayloadTo);
                                        range_to = tmpPayloadTo.out;
                                    } else {
                                    }
                                }
                            }

                            this.$store.state.fansTableData.params_table[setting.name] = {
                                units: [],
                                selected: selected,
                                infinityMin: parseInt(setting.range_from_infinity),
                                infinityMax: parseInt(setting.range_to_infinity),
                                default_infinityMin: parseInt(setting.range_from_infinity),
                                default_infinityMax: parseInt(setting.range_to_infinity),
                                title: setting.name,
                                type: setting.method_of_filtering,
                                range_from: range_from,
                                default_range_from: range_from,
                                range_to: range_to,
                                default_range_to: range_to,
                            }

                            if (this.$store.state.ValueUnitMap[setting.name]) {
                                Object.assign(this.$store.state.fansTableData.params_table[setting.name].units, this.$store.state.ValueUnitMap[setting.name].units);
                                Object.assign(this.$store.state.fansTableData.params_table[setting.name].selected, this.$store.state.ValueUnitMap[setting.name].selected);
                            }
                        }
                    }
                }
            },

          getPressure(paramType){
            for (let optionId in this.$store.state[paramType].pressure.options) {
              let option = this.$store.state[paramType].pressure.options[optionId];
              if (option.type && option.type == "radio") {
                for (let elementId in option.elements) {
                  let element = option.elements[elementId];

                  if (element.active)
                    return element.value;
                }
              }
            }
          },

          getCurrentPressure(){
              return this.getPressure("fourthStepParameters");
          },

          getSelectedPressure(){
            return this.getPressure("fourthStepParametersSelected");
          },

          // NVS-44 Funkcja sprawdza czy jest aktywny warunek sprawdzania wzrostu temperatury w danym typie wentylatora i zwraca true jeżeli suma temperatury z doboru i wzrostu jest większa od temperatury maksymalnej wentylatora
          checkTemperatureCondition(fan) {
            if (fan.params.fan_temperature_increase)
                return this.$store.state.selectedFirstStepElement.delta_t_condition_check == 1 && this.$store.state.fourthStepParametersSelected.temperature.value - 273.15 + fan.params.fan_temperature_increase - 273.15 > parseFloat(fan.engine.max_temperature);
            else 
                return this.$store.state.selectedFirstStepElement.delta_t_condition_check == 1 && this.$store.state.fourthStepParametersSelected.temperature.value - 273.15 > parseFloat(fan.engine.max_temperature);
          },
        },
        computed: {

            isEditable() {
                return this.$store.getters.isOfferEditable;
            },

            countSimilarFans() {
                this.manageSelectedFan();

                if (this.$store.state.fansTableData.FanTableRef)
                    return this.$store.state.fansTableData.FanTableRef.allFilteredData.length;
                else
                    return 0;
            },

            getCustomSortingMethods() {
                return this.$store.state.fansTableData.customSorting;
            },

            getCustomFilterMethods() {
                return this.$store.state.fansTableData.customFilters;
            },

            getFansTableData() {
                return this.$store.state.fansTableData.fans_table;
            },

            getParamColumnsData() {
                return this.$store.state.fansTableData.params_table;
            },

            getParamColumnsTitle() {

                let paramsArr = [];
                let columnsArr = [];
                let paramsObject = this.$store.state.fansTableData.params_table;

                Object.keys(paramsObject).forEach(function (param_id, keys) {
                    paramsArr.push(paramsObject[param_id].title);
                });

                columnsArr = this.main_data_columns.concat(paramsArr);

                return columnsArr;
            },

            getShortParamColumnsTitle() {
                let paramsArr = [];
                let paramsObject = this.$store.state.fansTableData.params_table;

                Object.keys(paramsObject).forEach(function (param_id, keys) {
                    paramsArr.push(paramsObject[param_id].title);
                });

                return paramsArr;
            },
        },

        beforeMount() {
            if (this.$store.state.reloadFansTableSetting) {
                this.LoadTableSettings();
                this.generateSortingMethod();
                this.generateFilteringMethods();
                this.tableHasReloadedBefore = true;
                this.$store.state.reloadFansTableSetting = false;
            }

            this.options.sortable = this.getShortParamColumnsTitle;
            this.options.customSorting = this.getCustomSortingMethods;
            this.options.customFilters = this.getCustomFilterMethods;
        },
        mounted() {
          let lastPressureType = this.$store.state.lastCalculationSelectedPressureType;
          let selectedPressureType = this.getSelectedPressure();

            this.$root.$on('order', (columnId) => {
                this.setSorting(columnId);
            })

            this.$store.state.fansTableData.FanTableRef = this.$refs.FanTable;
            this.$store.state.FansTable.columns = this.$store.state.fansTableData.FanTableRef.columns;

            if(!this.$store.state.productCard.loaded  && this.tableHasReloadedBefore) {
                this.setDefaultFilters();
                this.tableHasReloadedBefore = false;
            }

            if(lastPressureType != selectedPressureType){
              let secondPressureType = selectedPressureType == "total" ? "static" : "total";

              //Pressure settings
              let selectedPressureElement =  this.getParamColumnsData[selectedPressureType + '_pressure'];
              let secondPressureElement =  this.getParamColumnsData[secondPressureType + '_pressure'];

              if(selectedPressureElement){
                // NVS-60 zmiana z default_range_from/to na range_from/to
                let valueFrom = this.calcUnitRowElement(selectedPressureElement.range_from, selectedPressureType + '_pressure');
                let valueTo = this.calcUnitRowElement(selectedPressureElement.range_to, selectedPressureType + '_pressure');

                this.setFilter(selectedPressureElement, selectedPressureElement.default_infinityMin == 1 ? "" : valueFrom, "range_from");
                this.setFilter(selectedPressureElement, selectedPressureElement.default_infinityMax == 1 ? "" : valueTo, "range_to");
              }

              if(secondPressureElement){
                this.setFilter(secondPressureElement, "", "range_from");
                this.setFilter(secondPressureElement, "", "range_to");
              }

              //Efficiency settings
              let selectedEfficiencyElement =  this.getParamColumnsData[selectedPressureType + '_efficiency'];
              let secondEfficiencyElement =  this.getParamColumnsData[secondPressureType + '_efficiency'];

              if(selectedEfficiencyElement){
                let valueFrom = this.calcUnitRowElement(selectedEfficiencyElement.default_range_from, selectedPressureType + '_efficiency');
                let valueTo = this.calcUnitRowElement(selectedEfficiencyElement.default_range_to, selectedPressureType + '_efficiency');

                this.setFilter(selectedEfficiencyElement, selectedEfficiencyElement.default_infinityMin == 1 ? "" : valueFrom, "range_from");
                this.setFilter(selectedEfficiencyElement, selectedEfficiencyElement.default_infinityMax == 1 ? "" : valueTo, "range_to");
              }

              if(secondEfficiencyElement){
                this.setFilter(secondEfficiencyElement, "", "range_from");
                this.setFilter(secondEfficiencyElement, "", "range_to");
              }
            }

            // Ładujemy zapisane filtry jeśli wczytana oferta je zawiera
            if(this.$store.state.fansTableData.params_table_loaded && this.$store.state.productCard.loaded && this.load) {
                setTimeout(() => {
                for(let element in this.$store.state.fansTableData.params_table_loaded) {
                    if(this.$store.state.fansTableData.params_table_loaded[element].type === 'from_to' || this.$store.state.fansTableData.params_table_loaded[element].type === 'plus_minus') {
                        let inputs = document.querySelectorAll('.' + this.$store.state.fansTableData.params_table_loaded[element].title)
                        if(this.$store.state.fansTableData.params_table_loaded[element].range_from !== this.$store.state.fansTableData.params_table[element].range_from) {
                            inputs[0].value = this.$store.state.fansTableData.params_table_loaded[element].range_from
                            inputs[0].dispatchEvent(new Event('input', { bubbles: true }))
                        }
                        if(this.$store.state.fansTableData.params_table_loaded[element].range_to !== this.$store.state.fansTableData.params_table[element].range_to) {
                            inputs[1].value = this.$store.state.fansTableData.params_table_loaded[element].range_to
                            inputs[1].dispatchEvent(new Event('input', { bubbles: true }))
                        }
                    }
                }
                console.log('Fans Table data loaded');
            }, 0)
            }
        }
    }
</script>